export default __webpack_public_path__ + "static/media/logout.6b558d11.svg";